import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { L10nTranslationModule } from 'angular-l10n';
import { NzCollapseModule } from 'ng-zorro-antd/collapse';
import { NzIconModule } from 'ng-zorro-antd/icon';

import { CollapseComponent } from './collapse.component';

@NgModule({
  imports: [CommonModule, L10nTranslationModule, NzCollapseModule, NzIconModule],
  declarations: [CollapseComponent],
  exports: [CollapseComponent]
})
export class CollapseModule {}
